module.exports = __webpack_public_path__ + "static/adyen-501b2a814e5fa2aab786b0b33fbcf13b.svg";